import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INCIDENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.IncidentType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const INCIDENTTYPE_CONFIG = {
  entityName: 'IncidentType',
  localizationKey: 'Planning::Entity.IncidentType',
  fields: INCIDENTTYPE_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.IncidentTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
